import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { shallowEqual } from '../utils';

var Form = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Form, _React$Component);

  function Form() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isEditing: false,
      isSubmitting: false,
      payload: _this.props.initialPayload
    });

    _defineProperty(_assertThisInitialized(_this), "submitTimeoutId", null);

    _defineProperty(_assertThisInitialized(_this), "startSubmitTimeout", function () {
      _this.submitTimeoutId = setTimeout(_this.handleSubmit);
    });

    _defineProperty(_assertThisInitialized(_this), "clearSubmitTimeout", function () {
      clearTimeout(_this.submitTimeoutId);
      _this.submitTimeoutId = null;
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditing", function () {
      _this.setState({
        isEditing: true
      });

      if (_this.focusable) {
        _this.focusable.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleReset", function () {
      _this.setState({
        isEditing: false,
        payload: _this.props.initialPayload
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      if (JSON.stringify(_this.props.initialPayload) === JSON.stringify(_this.state.payload)) {
        _this.setState({
          isEditing: false
        });
      } else {
        var timeoutId = setTimeout(function () {
          _this.setState({
            isEditing: false,
            isSubmitting: true
          });
        });

        _this.props.onSubmit(_this.state.payload, function () {
          clearTimeout(timeoutId);

          _this.clearSubmitTimeout();

          _this.setState({
            isSubmitting: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "storeFocusRef", function (node) {
      if (!_this.focusable) {
        _this.focusable = node;
      }
    });

    return _this;
  }

  var _proto = Form.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (!shallowEqual(lastProps.initialPayload, this.props.initialPayload)) {
      this.setState({
        payload: this.props.initialPayload
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        isEditing = _this$state.isEditing,
        isSubmitting = _this$state.isSubmitting,
        payload = _this$state.payload;
    return this.props.children(_objectSpread(_objectSpread({}, this.state), {}, {
      editButtonProps: {
        disabled: isSubmitting,
        icon: isEditing ? undefined : {
          name: 'pencil'
        },
        onClick: function onClick() {
          // bail out if we've already triggered a submit in onBlur
          if (_this2.submitTimeoutId === null) {
            if (isEditing) {
              _this2.handleSubmit();
            } else {
              _this2.handleEditing();
            }
          }
        },
        spinner: isSubmitting,
        title: isEditing ? 'Save' : 'Edit',
        tooltip: isEditing ? isSubmitting ? {
          title: 'Saving'
        } : undefined : {
          title: 'Edit'
        }
      },
      getFieldProps: function getFieldProps(key, getChangeValue) {
        if (getChangeValue === void 0) {
          getChangeValue = function getChangeValue(event) {
            return event.target.value;
          };
        }

        return {
          innerRef: _this2.storeFocusRef,
          disabled: isSubmitting,
          hover: isEditing,
          value: payload[key],
          onFocus: function onFocus() {
            _this2.clearSubmitTimeout();

            _this2.setState({
              isEditing: true
            });
          },
          onBlur: function onBlur() {
            _this2.startSubmitTimeout();
          },
          onChange: function onChange(event) {
            var nextValue = getChangeValue(event);

            _this2.setState(function (state) {
              var _objectSpread2;

              return {
                payload: _objectSpread(_objectSpread({}, state.payload), {}, (_objectSpread2 = {}, _objectSpread2[key] = nextValue, _objectSpread2))
              };
            });
          },
          onKeyDown: function onKeyDown(event) {
            if (event.key === 'Enter' || event.key === 'Escape') {
              event.preventDefault();
              event.target.blur();

              if (event.key === 'Escape') {
                _this2.handleReset();
              }
            }
          }
        };
      }
    }));
  };

  return Form;
}(React.Component);

export default Form;